import React from 'react';
import { View, Text, StyleSheet, ScrollView, TouchableOpacity, Dimensions, Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Ionicons } from '@expo/vector-icons';
import { colors } from '../constants/colors';
import { useNavigation } from '@react-navigation/native';
import { SafeAreaView } from 'react-native-safe-area-context';

const { width } = Dimensions.get('window');
const CARD_MARGIN = 10;
const CARD_WIDTH = (width - 60) / 2;

export default function ResourcesScreen() {
  const insets = useSafeAreaInsets();
  const navigation = useNavigation();

  const resources = [
    {
      title: 'E-Learning',
      subtitle: 'Access your course materials',
      icon: 'laptop-outline',
      url: 'https://elearning.nust.na/login/index.php',
      color: colors.primary
    },
    {
      title: 'Student Portal',
      subtitle: 'View your academic records',
      icon: 'person-outline',
      url: 'https://ienabler.nust.na/pls/prodi41/w99pkg.mi_login',
      color: colors.secondary
    },
    {
      title: 'Course Timetables',
      subtitle: 'Check class schedules',
      icon: 'time-outline',
      url: 'https://www.nust.na/timetables',
      color: '#009688'
    },
    {
      title: 'Past Papers',
      subtitle: 'Practice with previous exams',
      icon: 'document-text-outline',
      url: 'https://exampapers.nust.na/greenstone3/library/collection/exampape/page/about',
      color: '#FF9800'
    },
    {
      title: 'Room Bookings',
      subtitle: 'Reserve study spaces',
      icon: 'calendar-outline',
      url: 'https://booking.nust.na/Web/',
      color: '#F44336'
    },
    {
      title: 'Societies',
      subtitle: 'Join student organizations',
      icon: 'people-outline',
      url: 'https://www.nust.na/student-societies',
      color: '#9C27B0'
    }
  ];

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.background,
    },
    content: {
      flex: 1,
      paddingHorizontal: 20,
    },
    header: {
      paddingTop: 20,
      paddingBottom: 15,
      backgroundColor: colors.surface,
      borderBottomLeftRadius: 24,
      borderBottomRightRadius: 24,
      marginHorizontal: -20,
      paddingHorizontal: 20,
      position: 'relative',
      ...Platform.select({
        ios: {
          shadowColor: colors.text,
          shadowOffset: { width: 0, height: 4 },
          shadowOpacity: 0.1,
          shadowRadius: 8,
        },
        android: {
          elevation: 4,
        },
      }),
    },
    headerContent: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    greetingContainer: {
      flex: 1,
    },
    greeting: {
      fontSize: 16,
      color: colors.textSecondary,
      marginBottom: 4,
      fontWeight: '500',
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    headerTitle: {
      fontSize: 32,
      fontWeight: '800',
      color: colors.text,
      letterSpacing: -1,
    },
    headerRight: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    searchButton: {
      width: 48,
      height: 48,
      borderRadius: 24,
      backgroundColor: 'rgba(0, 51, 102, 0.05)',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 12,
    },
    headerDecoration: {
      position: 'absolute',
      bottom: 0,
      left: 30,
      right: 30,
      height: 6,
      backgroundColor: colors.primary,
      opacity: 0.15,
      borderRadius: 3,
    },
    grid: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginTop: 20,
    },
    card: {
      width: CARD_WIDTH,
      backgroundColor: colors.surface,
      borderRadius: 16,
      padding: 16,
      marginBottom: 20,
      ...Platform.select({
        ios: {
          shadowColor: colors.text,
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.1,
          shadowRadius: 8,
        },
        android: {
          elevation: 2,
        },
      }),
    },
    iconContainer: {
      width: 48,
      height: 48,
      borderRadius: 24,
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 12,
    },
    cardTitle: {
      fontSize: 16,
      fontWeight: '600',
      color: colors.text,
      marginBottom: 4,
    },
    cardSubtitle: {
      fontSize: 14,
      color: colors.textSecondary,
    },
  });

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView style={styles.content} showsVerticalScrollIndicator={false}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerContent}>
            <View style={styles.greetingContainer}>
              <Text style={styles.greeting}>Student Resources</Text>
              <View style={styles.titleContainer}>
                <Text style={styles.headerTitle}>My</Text>
                <Text style={[styles.headerTitle, { color: colors.primary }]}> Resources</Text>
              </View>
            </View>
            <View style={styles.headerRight}>
   
            </View>
          </View>
          <View style={styles.headerDecoration} />
        </View>

        {/* Resources Grid */}
        <View style={styles.grid}>
          {resources.map((resource, index) => (
            <TouchableOpacity
              key={index}
              style={styles.card}
              onPress={() => navigation.navigate('WebView' as never, {
                url: resource.url,
                title: resource.title
              } as never)}
            >
              <View style={[styles.iconContainer, { backgroundColor: `${resource.color}15` }]}>
                <Ionicons 
                  name={resource.icon as any} 
                  size={28} 
                  color={resource.color} 
                />
              </View>
              <Text style={styles.cardTitle}>{resource.title}</Text>
              <Text style={styles.cardSubtitle}>{resource.subtitle}</Text>
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>
    </SafeAreaView>
  );
}
